<template>
  <b-table-simple
    bordered
    small
    fixed
    responsive
    class="mc-calendar bg-white"
  >
    <b-thead>
      <b-tr>
        <b-th v-for="date in dates" :key="date" class="text-center">
          {{ moment(date).format(dateFormat) }}
        </b-th>
      </b-tr>
    </b-thead>
    <b-tbody>
      <b-tr>
        <b-td v-for="date in dates" :key="date" :class="columnClass(date)">
          <a
            v-for="avail in availabilitiesByDate[date]"
            :key="avail.id"
            class="mc-event"
            :style="getStyle(avail)"
            :href="reserveUrl(avail)"
            @click="onClick($event, avail)"
          >
            <div v-if="!!getTitle(avail)" class="mc-title font-weight-bold">
              {{ getTitle(avail) }}
            </div>
            <div class="mc-time clearfix">
              <div v-if="!avail.extendedProps.is_closure" class="float-left">
                <div class="d-sm-none">
                  {{ moment(avail.start).format('LT').replace(' AM', 'a').replace(' PM', 'p') }}
                </div>
                <div class="d-none d-sm-block">
                  {{ moment(avail.start).format('LT') }}
                </div>
                <small v-if="avail.extendedProps.hint_availability && !avail.extendedProps.hint_availability.inline" class="text-muted text-nowrap">
                  ({{ avail.extendedProps.hint_availability.count }} {{trans('avail') }})
                </small>
                <small v-if="avail.extendedProps.hint_availability && !!avail.extendedProps.hint_availability.inline" class="text-muted text-nowrap">
                  ({{trans('avail') }}: {{ avail.extendedProps.hint_availability.inline }})
                </small>
              </div>
              <div v-if="avail.extendedProps.is_closure" class="float-left">
                {{ timeRangeStr(avail.extendedProps.closure_start, avail.extendedProps.closure_end, true) }}
                <small v-if="!!avail.extendedProps.booking_notes" class="d-block mt-1">
                  {{ avail.extendedProps.booking_notes }}
                </small>
              </div>
              <div v-if="avail.extendedProps.bookings && avail.extendedProps.bookings.length > 0" class="float-right">
                <i :class="`fa fa-fw ${avail.extendedProps.bookings[0].expired ? 'fa-exclamation-circle text-danger' : 'fa-check-circle text-success'}`"></i>
              </div>
            </div>
            <div v-if="avail.extendedProps.price !== undefined" class="mc-price font-weight-bold">
              {{ currency(avail.extendedProps.price) }}
            </div>
          </a>
          <div v-if="availabilitiesByDate[date].length == 0" class="mc-empty">
            &nbsp;
          </div>
        </b-td>
      </b-tr>
    </b-tbody>
    <package-class-event-modal
      :organization="organization"
      :event="event"
    ></package-class-event-modal>
  </b-table-simple>
</template>

<script>
  import PackageClassEventModal from './PackageClassEventModal'
  import querystring from 'querystring'

  export default {
    props: {
      organization: Object,
      dates: Array, // YYYY-MM-DD
      availabilities: Array,
      sortColumn: {
        type: String,
        default: 'start',
      },
      showTitle: {
        type: Boolean,
        default: false,
      },
    },
    components: {
      PackageClassEventModal,
    },
    data() {
      return {
        trans: trans,
        moment: moment,
        currency: _.currency,
        timeRangeStr: _.timeRangeStr,
        iframeUrlPrefix: _.iframeUrlPrefix,
        event: null,
      }
    },
    computed: {
      dateFormat() {
        return 'ddd D MMM'
      },
      availabilitiesByDate() {
        let availabilitiesByDate = {}
        _.each(this.dates, date => {
          availabilitiesByDate[date] = []
        })
        _.each(this.availabilities, avail => {
          let date = moment(avail.start).format('YYYY-MM-DD')
          if (availabilitiesByDate[date] && 
          (!avail.extendedProps.hint_availability || avail.extendedProps.hint_availability.count > 0)) {
            availabilitiesByDate[date].push(avail)
          }
        })
        _.each(availabilitiesByDate, (availabilities, date) => {
          availabilitiesByDate[date] = _.sortBy(availabilities, this.sortColumn)
        })
        return availabilitiesByDate
      },
    },
    watch: {
    },
    methods: {
      getTitle(avail) {
        return this.showTitle ||
          avail.extendedProps.is_closure ||
          !!avail.extendedProps.am_class_id ?
          avail.title :
          null
      },
      getStyle(avail) {
        if (avail.extendedProps.is_closure) {
          return `background-color: ${avail.color}; color: ${avail.textColor}; border-color: ${avail.borderColor};`
        }
        if (!!avail.extendedProps.am_class_id) {
          return `background-color: ${avail.color}; color: ${avail.textColor}; border-color: ${avail.color};`
        }
        return `border-color: ${avail.borderColor};`
      },
      columnClass(date) {
        let classes = ['mc-day']
        let m = moment(date, 'YYYY-MM-DD')
        if (m.day() == 6 || m.day() == 0) classes.push('mc-weekend')
        if (m.isSame(moment(), 'day')) classes.push('mc-today')
        return classes.join(' ')
      },
      reserveUrl(avail) {
        let query = querystring.parse(window.location.search.substring(1))
        query.book_at = avail.start
        query.p = 'availability'
        return `${this.iframeUrlPrefix}/org/${this.organization.id}/package/${avail.extendedProps.package_id}?${querystring.encode(query)}`
      },
      onClick(e, avail) {
        if (avail.extendedProps.is_closure) {
          e.preventDefault()
          e.stopImmediatePropagation()
          return false
        }
        if (!!avail.extendedProps.am_class_id) {
          this.event = avail
          this.$bvModal.show('package-class-event-modal')
        }
        this.$emit('click-avail', e, avail)
      },
    },
    mounted() {
      window.calendar = this
    },
  }
</script>